import * as moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  RSelect,
} from "../../components/Component";
import { DELETE, GET, POST } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import { getToken } from "../../helper/auth";

const BillExternalContractManager = () => {
  const clearPagi = useRef();
  const [deliveryProviderColObj, setDeliveryProviderColObj] = useState({});
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    addReport: false,
    isDelete: false,
    isDuplicate: false,
  });

  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [duplicateId, setDuplicateId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [rangeDate, setRangeDate] = useState({
    startDate: moment(searchParams.get("startDate") || undefined)
      .startOf("years")
      .toDate(),
    endDate: moment(searchParams.get("endDate") || undefined)
      .endOf("days")
      .toDate(),
  });

  const [filter, setFilter] = useState({
    customerId: searchParams.get("customerId") || undefined,
    type: searchParams.get("type") || undefined,
    ingredientId: searchParams.get("ingredientId") || undefined,
    status: searchParams.get("status") || undefined,
    redFlag: searchParams.get("redFlag") || undefined,
    isExchangeInternalInventory:
      searchParams.get("isExchangeInternalInventory") || undefined,
    completed: searchParams.get("completed") || undefined,
  });
  const [customerOptions, setCustomerOptions] = useState([]);

  const completedOptions = [
    { value: "true", label: "Đã hoàn thành" },
    { value: "false", label: "Chưa hoàn thành" },
  ];

  const numColDeliveryProvider = useMemo(() => {
    let count = 0;
    Object.values(deliveryProviderColObj).forEach(e => {
      const warehouseKey = Object.keys(e?.warehouse || {}).length
      count += warehouseKey + 1
    })
    return count;
  }, [deliveryProviderColObj])
  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.completed !== undefined ? { completed: filter.completed } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });
    getData();
  }, [timeNow, filter]);

  const getData = () => {
    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
        startDate: moment(rangeDate.startDate).toDate(),
        endDate: moment(rangeDate.endDate).toDate(),
        ...(filter.customerId ? { customerId: filter.customerId } : {}),
        ...(filter.completed !== undefined ? { completed: filter.completed } : {}),
      };

      GET(`bill-external-contract`, params, true)
        .then(({ data }) => {
          const rows = data?.rows || [];
          setData([...rows]);
          setDeliveryProviderColObj(data.deliveryProviderColObj);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  };

  useEffect(() => {
    GET("customer", {}, true).then((resp) => {
      setCustomerOptions(
        resp.data?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, []);

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ isDelete: false, isDuplicate: false, addReport: false });
  };

  const deleteOrder = (id) => {
    if (!id) {
      return;
    }
    DELETE(`bill-external-contract/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa đơn thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const duplicateBillContract = (id) => {
    if (!id) {
      return;
    }
    POST(`bill-external-contract/duplicate/${id}`, {}, {}, true)
      .then(() => {
        toast.success("Nhân bản đơn thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate
        ? moment(startDate)?.startOf("days").toDate()
        : startDate,
      endDate: endDate ? moment(endDate)?.endOf("days").toDate() : endDate,
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };

  const exportExcel = () => {
    const params = new URLSearchParams({
      startDate: moment(rangeDate.startDate).toDate(),
      endDate: moment(rangeDate.endDate).toDate(),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.completed !== undefined ? { completed: filter.completed } : {}),
      token: getToken(),
    });
    const url = `${process.env.REACT_APP_API_URL
      }/api/v1/bill-external-contract/find-all-excel?${params.toString()}`;
    window.open(url, "_blank");
  };

  return (
    <React.Fragment>
      <Head title="Quản lý hợp đồng xuất khẩu"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Hợp đồng xuất khẩu</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">

                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Khách hàng/Nhà cung cấp"
                          options={customerOptions}
                          value={
                            customerOptions.find(
                              (c) => c.value == filter.customerId
                            ) || ""
                          }
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              customerId: val?.value || undefined,
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Trạng thái hoàn thành"
                          options={completedOptions}
                          value={
                            completedOptions.find(
                              (c) => c.value === filter.completed
                            ) || ""
                          }
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              completed: val?.value ?? undefined,
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button
                          color="primary"
                          onClick={() => {
                            history.push("/bill-external-contract/create");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm</span>
                        </Button>
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button color="secondary" onClick={exportExcel}>
                          <span>Xuất excel</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <table className="table-bordered w-100 table table-responsive">
                    <tbody>
                      <tr>
                        <td rowSpan={3}>Tên hợp đồng</td>
                        <td rowSpan={3}>Mã khách hàng</td>
                        <td rowSpan={3}>Ngày hợp đồng</td>
                        <td rowSpan={3}>Ngày tàu chạy</td>

                        <td rowSpan={3}>Số lượng theo hợp đồng</td>
                        <td rowSpan={3}>Số lượng thực đóng</td>
                        <td rowSpan={3}>Đơn giá($)</td>
                        <td rowSpan={3}>Thành tiền ($)</td>
                        <td rowSpan={3}>Số lượng container</td>
                        <td rowSpan={3}>Ngày hoàn thành</td>
                        <td rowSpan={3}>Tiền gửi/tấn($)</td>

                        {numColDeliveryProvider > 0 && <td
                          rowSpan={1}
                          colSpan={numColDeliveryProvider}
                        >
                          ĐƠN VỊ VẬN TẢI VÀ KHO XUẤT
                        </td>
                        }

                        <td rowSpan={2} colSpan={4}>
                          Phí cảng bãi
                        </td>
                        <td rowSpan={2} colSpan={3}>
                          Bảo hiểm
                        </td>
                        <td rowSpan={2} colSpan={10}>
                          Phí tàu quốc tế
                        </td>
                        <td rowSpan={2} colSpan={4}>
                          CHI PHÍ CỐ ĐỊNH
                        </td>
                        <td rowSpan={3}>Đơn giá net kho</td>
                        <td rowSpan={3}>Người quản lý</td>
                        <td rowSpan={3}>Tổng cộng</td>
                        <td rowSpan={3}>Hành động</td>
                      </tr>

                      <tr>
                        {Object.values(deliveryProviderColObj).map(provider =>
                          <td colSpan={Object.keys(provider.warehouse || {}).length + 1}>{provider.name}</td>
                        )}
                      </tr>

                      <tr>
                        <>
                          {Object.values(deliveryProviderColObj).map(provider =>
                            <>
                              {
                                Object.values(provider.warehouse || {}).map((warehouse) =>
                                  <td>{warehouse.name}</td>
                                )
                              }
                              <td>Thành tiền</td>
                            </>
                          )}

                          <td>Phí nâng</td>
                          <td>Phí hạ</td>
                          <td>Bồi dưỡng</td>
                          <td>CSHT</td>

                          <td>USD</td>
                          <td>Tỷ giá</td>
                          <td>VND</td>

                          <td>Tỷ giá</td>
                          <td>Cước/cont USD</td>
                          <td>Thành tiền USD</td>
                          <td>Thành tiền VND</td>
                          <td>Bill tàu/bộ</td>
                          <td>Seal/con/USD</td>
                          <td>Phí dịch vụ hải quan</td>
                          <td>Thành tiền VND</td>
                          <td>Thuế VAT</td>
                          <td>Thành tiền VND</td>

                          <td>TỶ GIÁ </td>
                          <td>TÚI</td>
                          <td>HOA HỒNG</td>
                          <td>PHÍ NGÂN HÀNG + CÔNG ĐÓNG</td>
                        </>
                      </tr>

                      {(data &&
                        data.length &&
                        data.map((c) => (
                          <tr>
                            <td>{c.name}</td>
                            <td>{c?.customer?.name}</td>
                            <td>
                              {moment(c.contractSignDate).format("DD/MM/YYYY")}
                            </td>
                            <td>
                              {c.shipStartDate &&
                                moment(c.shipStartDate).format("DD/MM/YYYY")}
                            </td>

                            <td><NumericFormat
                              value={c.contractQuantity || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            /></td>
                            <td><NumericFormat
                              value={c.quantity || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            /></td>
                            <td><NumericFormat
                              value={c.contractUnitPrice || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            /></td>
                            <td><NumericFormat
                              value={c.contractSubtotal || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            /></td>
                            <td><NumericFormat
                              value={c.numOfContainer || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            /></td>
                            <td>
                              {c.completedDate &&
                                moment(c.completedDate).format("DD/MM/YYYY")}
                            </td>
                            <td><NumericFormat
                              value={c.attachFeeUnitPrice || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            /></td>
                            {Object.values(deliveryProviderColObj).map(provider =>
                              <>
                                {
                                  Object.values(provider.warehouse || {}).map(warehouse =>
                                    <td>
                                      <NumericFormat
                                        value={c.deliveryProvider?.[provider.id]?.[warehouse.id]?.numOfContainer || 0}
                                        displayType={'text'}
                                        decimalScale={2}
                                        thousandSeparator={','}
                                        thousandsGroupStyle="thousand"
                                      />
                                    </td>
                                  )
                                }
                                <td>
                                  <NumericFormat
                                    value={
                                      Object.values(provider.warehouse || {}).reduce((prev, warehouse) => prev + (c.deliveryProvider?.[provider.id]?.[warehouse.id]?.deliveryFeeExternal || 0), 0)
                                    }
                                    displayType={'text'}
                                    decimalScale={2}
                                    thousandSeparator={','}
                                    thousandsGroupStyle="thousand"
                                  />
                                </td>
                              </>
                            )}
                            <td >
                              <NumericFormat
                                value={c.liftOnFee}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.liftOffFee}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.inDriverFosteringUpDownContainerFee}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.infrastructureFee}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>

                            <td >
                              <NumericFormat
                                value={c.insuranceUsdFee}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.insuranceExchangeRate}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.insuranceFee}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>

                            <td>
                              <NumericFormat
                                value={c.shipFeeExchangeRate}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.shipFeeUnitPrice}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.shipFeeUsdSubtotal}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td >
                              <NumericFormat
                                value={c.shipFeeSubtotal}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.shipFeebillFee}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>

                            <td>
                              <NumericFormat
                                value={c.shipFeeSealFeePerContainer}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />

                            </td>
                            <td>
                              <NumericFormat
                                value={c.shipFeeCustomFee}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.shipFeeSubtotalBeforeTax}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.shipFeeVat}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.shipFeeSubtotalIncludeTax}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />

                            </td>

                            <td>
                              <NumericFormat
                                value={c.baseFeeExchangeRate}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td >
                              <NumericFormat
                                value={c.baseFeePackageFee}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.baseFeeCommissionFeePerWeightRate}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.baseFeeBankFee}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c.exWarehouseUnitPrice}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              {c.handler?.name}
                            </td>
                            <td>
                              <NumericFormat
                                value={c.total}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  tag="a"
                                  className="btn btn-icon dropdown-toggle btn-trigger"
                                >
                                  <Icon name="more-h"></Icon>
                                </DropdownToggle>
                                <DropdownMenu right>
                                  <ul className="link-list-opt no-bdr">
                                    <li>
                                      <a
                                        tag="a"
                                        href="#dropdown"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          history.push(
                                            "/bill-external-contract/" + c.id
                                          );
                                        }}
                                      >
                                        <Icon
                                          name="edit"
                                          className="text-primary"
                                        ></Icon>
                                        <span>Sửa</span>
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        tag="a"
                                        href="#dropdown"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          history.push(
                                            "/bill-external-contract-estimate/" + c.id
                                          );
                                        }}
                                      >
                                        <Icon
                                          name="edit"
                                          className="text-primary"
                                        ></Icon>
                                        <span>Giá net</span>
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        tag="a"
                                        href="#dropdown"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setDuplicateId(c.id);
                                          setView({ isDuplicate: true });
                                        }}
                                      >
                                        <Icon
                                          name={"copy"}
                                        ></Icon>
                                        <span>Nhân bản</span>
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        tag="a"
                                        href="#dropdown"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setDeleteId(c.id);
                                          setView({ isDelete: true });
                                        }}
                                      >
                                        <Icon
                                          name="trash"
                                          className="text-danger"
                                        ></Icon>
                                        <span>Xoá</span>
                                      </a>
                                    </li>
                                  </ul>
                                </DropdownMenu>
                              </UncontrolledDropdown>

                            </td>
                          </tr>
                        ))) || (
                          <tr>
                            <td colSpan={999}>Không có dữ liệu</td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal isOpen={view.isDuplicate} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <h4 className="nk-modal-title">
                Bạn có chắc muốn nhân bản hợp đồng xuất khẩu này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    duplicateBillContract(duplicateId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá hợp đồng xuất khẩu này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default BillExternalContractManager;
